import { useState } from 'react';

import { useService } from '../../store/useService';
import { sortByLabel } from '../Utils/Utils';
import { GET_TAGS_CONFIGURATION } from './GetTagsConfigurationService';

export function transformDataForDropdown(tagsConfigurationResponse: any): any {
  const tagsData: { label: any; value: any }[] = [];
  Object.keys(tagsConfigurationResponse).forEach((tag) => {
    tagsData.push({
      label: tagsConfigurationResponse[tag].tagName,
      value: tagsConfigurationResponse[tag].tagName,
    });
  });
  return tagsData.sort(sortByLabel);
}

interface useGetTagsConfigurationProps {
  onCompleted?: (tags: string[]) => void;
}

export const useGetTagsConfiguration = ({ onCompleted }: useGetTagsConfigurationProps) => {
  const [tags, setTags] = useState({});
  const { useLazyQuery } = useService();

  const [getTagsConfiguration, { loading, error, called, data }] = useLazyQuery(GET_TAGS_CONFIGURATION, {
    fetchPolicy: 'cache-first',
    onCompleted: (data: { getTagsConfiguration: { tags: any } }) => {
      let tags = transformDataForDropdown(data?.getTagsConfiguration?.tags);
      setTags(tags);
      onCompleted && onCompleted(tags);
    },
  });

  return {
    getTagsConfiguration,
    called,
    loading,
    error,
    data,
    tags: tags,
  };
};

export default useGetTagsConfiguration;
